import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-export-email',
  templateUrl: './help-add-export-email.component.html',
  styleUrls: ['./help-add-export-email.component.scss']
})
export class HelpAddExportEmailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
